/*
 * Sable — conditional variant options (generic, data-driven).
 *
 * Reads the product's real variants and, for the current selection:
 *   1. hides option values that can't be reached, and
 *   2. collapses (hides) any option whose reachable choices reduce to one
 *      — e.g. "Size" for an Unstitched suit whose only size value is the
 *      hidden "One Size" placeholder.
 *
 * Nothing is hardcoded to a specific option name, so it works for ANY product
 * or collection. Dependency direction follows Shopify option order: an option
 * is filtered only by the options BEFORE it (option 1 is never filtered), which
 * is exactly how Shopify variants are structured.
 */
(function () {
  if (window.SableConditionalVariants) return;
  window.SableConditionalVariants = true;

  function slice(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function readVariants(vs) {
    var el = vs.querySelector('[data-sable-variants]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function fieldsetsOf(vs) {
    return slice(vs.querySelectorAll('.product-form__input'));
  }

  function controlsOf(fs) {
    var radios = slice(fs.querySelectorAll('input[type="radio"]'));
    if (radios.length) return { type: 'radio', radios: radios, select: null };
    var select = fs.querySelector('select');
    return { type: select ? 'select' : 'none', radios: [], select: select };
  }

  function currentValue(fs) {
    var c = controlsOf(fs);
    if (c.type === 'radio') {
      for (var i = 0; i < c.radios.length; i++) {
        if (c.radios[i].checked) return c.radios[i].value;
      }
      return null;
    }
    if (c.type === 'select') return c.select.value;
    return null;
  }

  function allValues(fs) {
    var c = controlsOf(fs);
    if (c.type === 'radio') return c.radios.map(function (r) { return r.value; });
    if (c.type === 'select') return slice(c.select.options).map(function (o) { return o.value; });
    return [];
  }

  // Does a variant exist with option[i] === value AND option[j] === sel[j] for all j < i?
  function reachable(variants, i, value, sel) {
    for (var k = 0; k < variants.length; k++) {
      var opts = variants[k].options;
      if (opts[i] !== value) continue;
      var ok = true;
      for (var j = 0; j < i; j++) {
        if (sel[j] != null && opts[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  function setValue(fs, value) {
    var c = controlsOf(fs);
    if (c.type === 'radio') {
      c.radios.forEach(function (r) { r.checked = r.value === value; });
    } else if (c.type === 'select') {
      slice(c.select.options).forEach(function (o) {
        var on = o.value === value;
        o.selected = on;
        if (on) o.setAttribute('selected', 'selected');
        else o.removeAttribute('selected');
      });
      c.select.value = value;
    }
  }

  // Values that are placeholders, not real choices. An option collapses only
  // when its single remaining value is one of these; a lone real value (e.g.
  // "Unstitched") stays visible so it shows on the page and the order/invoice.
  var PLACEHOLDER_VALUES = { 'one size': 1, 'standard': 1, 'none': 1 };

  function isPlaceholder(value) {
    return PLACEHOLDER_VALUES[String(value == null ? '' : value).toLowerCase().trim()] === 1;
  }

  // Hide unreachable values + collapse an option that offers no real choice
  // (nothing reachable, or a single reachable value that is only a placeholder).
  function applyHiding(vs) {
    var variants = readVariants(vs);
    if (!variants || !variants.length) return;
    var fs = fieldsetsOf(vs);
    var sel = fs.map(currentValue);

    fs.forEach(function (group, i) {
      var c = controlsOf(group);
      var shown = 0;
      var lastValue = null;
      if (c.type === 'radio') {
        c.radios.forEach(function (r) {
          var ok = reachable(variants, i, r.value, sel);
          r.style.display = ok ? '' : 'none';
          var label = group.querySelector('label[for="' + r.id + '"]');
          if (label) label.style.display = ok ? '' : 'none';
          if (ok) { shown++; lastValue = r.value; }
        });
      } else if (c.type === 'select') {
        slice(c.select.options).forEach(function (o) {
          var ok = reachable(variants, i, o.value, sel);
          o.hidden = !ok;
          o.disabled = !ok;
          if (ok) { shown++; lastValue = o.value; }
        });
      }
      // Collapse only when there's no real choice: nothing reachable, or a single
      // reachable value that is just a placeholder. A lone real value stays shown.
      var collapse = shown === 0 || (shown === 1 && isPlaceholder(lastValue));
      group.style.display = collapse ? 'none' : '';
    });
  }

  // Repair dependent (later) options so the selection maps to a real variant.
  function repairSelection(vs, changedFs) {
    var variants = readVariants(vs);
    if (!variants || !variants.length) return;
    var fs = fieldsetsOf(vs);
    var changedIndex = fs.indexOf(changedFs);
    if (changedIndex < 0) return;
    var sel = fs.map(currentValue);

    for (var j = changedIndex + 1; j < fs.length; j++) {
      if (reachable(variants, j, sel[j], sel)) continue;
      var vals = allValues(fs[j]);
      for (var v = 0; v < vals.length; v++) {
        if (reachable(variants, j, vals[v], sel)) {
          setValue(fs[j], vals[v]);
          sel[j] = vals[v];
          break;
        }
      }
    }
  }

  function initProductInfo(pi) {
    if (pi.dataset.sableCond === '1') return;
    pi.dataset.sableCond = '1';

    // Repair the selection before Dawn reads it (capture beats variant-selects' bubble handler).
    pi.addEventListener(
      'change',
      function (e) {
        var vs = pi.querySelector('variant-selects');
        if (!vs || !vs.contains(e.target)) return;
        var group = e.target.closest('.product-form__input');
        if (group) repairSelection(vs, group);
      },
      true
    );

    // Re-apply hiding whenever Dawn swaps in a fresh <variant-selects>.
    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var a = 0; a < added.length; a++) {
          var n = added[a];
          if (n.nodeType !== 1) continue;
          var vs = n.matches && n.matches('variant-selects') ? n : n.querySelector && n.querySelector('variant-selects');
          if (vs) { applyHiding(vs); return; }
        }
      }
    });
    observer.observe(pi, { childList: true, subtree: true });

    var initialVs = pi.querySelector('variant-selects');
    if (initialVs) applyHiding(initialVs);
  }

  function initAll() {
    slice(document.querySelectorAll('product-info')).forEach(initProductInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor / dynamically loaded products.
  document.addEventListener('product-info:loaded', function (e) {
    if (e.target && e.target.matches && e.target.matches('product-info')) initProductInfo(e.target);
  });
})();